// src/features/inventory/services/lots.js
import { apiClient } from '../../../services/api/client';

export const lotsAPI = {
  getByItem: (itemId) =>
    apiClient.get(`/api/v1/inventory/lots/?item_id=${itemId}`),

  getById: (lotId) =>
    apiClient.get(`/api/v1/inventory/lots/${lotId}`),

  filterLots: (body = {}) =>
    apiClient.post('/api/v1/inventory/lots/filter', body),

  updateStatus: (lotId, { status, notes }) =>
    apiClient.put(`/api/v1/inventory/lots/${lotId}/status`, { status, notes }),

  // unit_cost (DKK incl. moms) needs inventory:cost:update; left out, the item's cost price is used
  create: ({ item_id, lot_number, initial_quantity, expiry_date, production_date, notes, location_id, unit_cost = null, update_cost_price = true }) =>
    apiClient.post('/api/v1/inventory/lots/', {
      item_id,
      lot_number,
      initial_quantity,
      expiry_date: expiry_date || null,
      production_date: production_date || null,
      notes: notes || null,
      location_id: location_id || null,
      unit_cost,
      update_cost_price,
    }),
};
